(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["licks-configurator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MODELS_ADV = {"AJP": ["PR7 650 2019-2025"], "Aprilia": ["TUAREG 660 2022-2025"], "Benelli": ["TRK 502 2016-2025", "TRK 502 X 2016-2025", "TRK 702 2022-2025", "TRK 702 X 2022-2025"], "BMW": ["F 650 GS 2011-2017", "F 750 GS 2018-2024", "F 800 GS 2008-2012", "F 800 GS 2013-2018", "F 850 GS 2019-2024", "F 900 GS 2024-2025", "R 1200 GS 2013-2016", "R 1200 GS 2017-2023", "R 1250 GS 2017-2024", "R 1300 GS 2023-2025"], "Ducati": ["DESERT X 2022-2025 (STD / RALLY)", "MULTISTRADA V4 2021-2025", "MULTISTRADA V2 2022-2025", "MULTISTRADA 1200 2010-2014", "MULTISTRADA 1200 2015-2017", "MULTISTRADA 1260 2018-2020"], "CF Moto": ["450 MT 2024-2025", "800 MT 2023-2025", "800 MT-X 2025"], "Honda": ["AFRICA TWIN CRF 1000 L 2015-2019 (STD / SPORT)", "AFRICA TWIN CRF 1100 L 2020-2023", "AFRICA TWIN CRF 1100 L 2024-2025", "TRANSALP 750 2023-2025", "NT 1100 2022-2024", "NX 500 2024-2025", "X ADV 750 2017-2020", "X ADV 750 2021-2025"], "Husqvarna": ["NORDEN 901 2020-2025"], "Kove": ["450 RALLY 2022-2025", "800 X 2022-2025"], "KTM": ["390 ADVENTURE 2020-2025", "790 - 890 ADVENTURE 2018-2022", "790 - 890 ADVENTURE 2023-2025", "890 SMT 2023-2025", "990 ADVENTURE 2006-2013", "1050 1090 1190 ADVENTURE 2017-2022", "1290 ADVENTURE 2017-2020", "1290 ADVENTURE 2021-2025"], "Moto Morini": ["X-CAPE 650 2021-2025", "X-CAPE 700 2024-2025"], "Suzuki": ["V-STROM 650 2017-2021", "V-STROM 800 2019-2025", "V-STROM 1050 2019-2025"], "Triumph": ["TIGER 1200 2016-2021"], "Yamaha": ["XT 1200 Z SUPER TENERE 2017-2020", "TRACER 9 2021-2024", "TRACER 7 2020-2025", "TENERE World Raid 700 2018-2024", "TENERE 700 2018-2024", "TENERE 700 2025"]};
    var MODELS_SCO = {"Gilera": ["TYPHOON"], "Malaguti": ["PHANTOM F12 E F12-R"], "Piaggio": ["ZIP SP MK1", "ZIP SP MK2", "ZIP SP MK2 4T"], "Yamaha": ["AEROX 50 1999-2012", "BOOSTER 50 BWS BCD AFTERMARKET", "BOOSTER 50 MBK SPIRIT 1999-2002", "BOOSTER 50 BWS 2004-2017", "BOOSTER 50 BWS 1989-2003"]};
    var MODELS = {
      'KTM': ['SX 50', 'SX 65', 'SX 85', 'SX 125', 'SX 150', 'SX 250', 'SX-F 250', 'SX-F 350', 'SX-F 450', 'EXC 125', 'EXC 150', 'EXC 250', 'EXC 300', 'EXC-F 250', 'EXC-F 350', 'EXC-F 450', 'EXC-F 500', 'SMR 450', 'Freeride', 'Duke 125', 'Duke 390', 'Duke 790/890', 'Super Duke 1290', '690 SMC R', '690 Enduro R', '390 Adventure', '790/890 Adventure', '1290 Super Adventure'],
      'Husqvarna': ['TC 50', 'TC 65', 'TC 85', 'TC 125', 'TC 250', 'FC 250', 'FC 350', 'FC 450', 'TE 150', 'TE 250', 'TE 300', 'FE 250', 'FE 350', 'FE 450', 'FE 501', 'FS 450', '701 Supermoto', '701 Enduro', 'Vitpilen 401', 'Svartpilen 401', 'Norden 901'],
      'GasGas': ['MC 50', 'MC 65', 'MC 85', 'MC 125', 'MC 250', 'MC 250F', 'MC 350F', 'MC 450F', 'EC 250', 'EC 300', 'EC 250F', 'EC 350F', 'EC 450F', 'ES 700', 'SM 700'],
      'Beta': ['RR 125 2T', 'RR 200', 'RR 250 2T', 'RR 300 2T', 'RR 350', 'RR 390', 'RR 430', 'RR 480', 'RR 125 LC 4T', 'RR 125 T', 'Xtrainer 250/300', 'Alp'],
      'Yamaha': ['YZ 65', 'YZ 85', 'YZ 125', 'YZ 250', 'YZ 250F', 'YZ 450F', 'WR 250F', 'WR 450F', 'Ténéré 700', 'MT-07', 'MT-09', 'XSR', 'R7'],
      'Honda': ['CRF 110', 'CRF 150R', 'CRF 250R', 'CRF 450R', 'CRF 250RX', 'CRF 450RX', 'CRF 250L/300L', 'CRF 450L', 'CRF 1100 Africa Twin', 'Hornet', 'CB'],
      'Kawasaki': ['KX 65', 'KX 85', 'KX 112', 'KX 250', 'KX 450', 'KLX 300', 'KLX 450R', 'Z 650/900', 'Ninja'],
      'Suzuki': ['RM 85', 'RM-Z 250', 'RM-Z 450', 'DR-Z 400', 'V-Strom', 'GSX-S', 'GSX-R'],
      'Altra marca': []
    };

    function fmt(cents) {
      cents = Math.round(cents);
      var e = Math.floor(cents / 100), c = cents % 100;
      return '€' + e.toLocaleString('it-IT') + (c ? ',' + (c < 10 ? '0' : '') + c : '');
    }

    function init(root) {
      if (!root || root.dataset.lkInit) return;
      root.dataset.lkInit = '1';

      var cfgEl = root.querySelector('[data-licks-prices]');
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[licks-configurator] config JSON non valido', e); return; }
      cfg.supp = cfg.supp || {};

      var form = root.querySelector('[data-lk-form]');
      var totals = root.querySelectorAll('[data-lk-total]');
      var linesEl = root.querySelector('[data-lk-lines]');
      var alertEl = root.querySelector('[data-lk-alert]');
      var mbarMissing = root.querySelector('[data-lk-mbar-missing]');
      var submitBtn = root.querySelector('[data-lk-submit]');
      var btnLabel = root.querySelector('[data-lk-btn-label]');

      /* ---------- Galleria ---------- */
      var thumbs = root.querySelectorAll('[data-lk-thumb]');
      var slides = root.querySelectorAll('[data-lk-slide]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.dataset.lkThumb;
          slides.forEach(function (s) { s.hidden = s.dataset.lkSlide !== i; });
          thumbs.forEach(function (x) {
            var on = x === t;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      });

      /* ---------- Scroll morbido ---------- */
      root.querySelectorAll('[data-lk-scroll]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          var target = document.querySelector(a.getAttribute('href'));
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      /* ---------- Dialog guida materiali ---------- */
      var dialog = root.querySelector('[data-lk-guide]');
      if (dialog) {
        root.querySelectorAll('[data-lk-open-guide]').forEach(function (b) {
          b.addEventListener('click', function () {
            if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
          });
        });
        root.querySelectorAll('[data-lk-guide-close]').forEach(function (b) {
          b.addEventListener('click', function () { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); });
        });
        dialog.addEventListener('click', function (e) { if (e.target === dialog) { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); } });
      }

      if (!form) return;

      /* ---------- Modelli per marca (select dipendente) ---------- */
      var brandSel = form.querySelector('[data-lk-brand]');
      var modelSel = form.querySelector('[data-lk-model-select]');
      var modelOther = form.querySelector('[data-lk-model-other]');
      var modelHidden = form.querySelector('[data-lk-model-hidden]');
      var OTHER = '__altro__';
      function opt(value, label) { var o = document.createElement('option'); o.value = value; o.textContent = label; return o; }
      function syncModel() {
        if (!modelSel || !modelHidden) return;
        var other = modelSel.value === OTHER;
        if (modelOther) {
          modelOther.hidden = !other;
          if (other) { modelOther.setAttribute('data-lk-required', ''); modelOther.setAttribute('required', ''); }
          else { modelOther.removeAttribute('data-lk-required'); modelOther.removeAttribute('required'); modelOther.value = ''; }
        }
        modelHidden.value = other ? (modelOther ? modelOther.value.trim() : '') : modelSel.value;
      }
      function fillModels() {
        if (!brandSel || !modelSel) return;
        var brand = brandSel.value;
        var map = form.dataset.lkKit === 'adventure' ? MODELS_ADV : (form.dataset.lkKit === 'scooter' ? MODELS_SCO : MODELS);
        var list = map[brand] || [];
        modelSel.innerHTML = '';
        if (!brand) { modelSel.appendChild(opt('', 'Prima scegli la marca')); modelSel.disabled = true; syncModel(); return; }
        modelSel.disabled = false;
        if (list.length) {
          modelSel.appendChild(opt('', 'Seleziona il modello ' + brand));
          list.forEach(function (m) { modelSel.appendChild(opt(m, m)); });
          modelSel.appendChild(opt(OTHER, 'Altro / non in lista…'));
        } else {
          modelSel.appendChild(opt(OTHER, 'Scrivi marca e modello'));
        }
        syncModel();
      }
      /* lista unica (adventure / scooter) */
      var listSel = form.querySelector('[data-lk-list-select]');
      var listOther = form.querySelector('[data-lk-list-other]');
      var listHidden = form.querySelector('[data-lk-list-hidden]');
      function syncList() {
        if (!listSel || !listHidden) return;
        var other = listSel.value === OTHER;
        if (listOther) {
          listOther.hidden = !other;
          if (other) { listOther.setAttribute('data-lk-required', ''); listOther.setAttribute('required', ''); }
          else { listOther.removeAttribute('data-lk-required'); listOther.removeAttribute('required'); listOther.value = ''; }
        }
        listHidden.value = other ? (listOther ? listOther.value.trim() : '') : listSel.value;
      }
      /* ---------- ALTRO nell'elenco modelli (adventure / scooter) ----------
         Il campo Modello e' un combo con ricerca in modalita' strict: si sceglie solo
         dall'elenco. In coda all'elenco c'e' la voce ALTRO; quando viene scelta compare
         la casella dove il cliente scrive il suo modello a mano.
         Il combo emette 'change' sul proprio input quando si sceglie una voce, quindi
         basta ascoltare li'. properties[MODELLO] resta "ALTRO…" e il testo scritto
         viaggia come proprieta' separata: nell'ordine Licks vede subito che e' un caso
         da confermare, non un kit gia' pronto. */
      /* ⚠️ questo blocco sta dentro {% javascript %}: Shopify NON interpreta il Liquid qui,
         quindi il valore della voce ALTRO arriva da un data- attribute, non da un'interpolazione. */
      var altroWrap = form.querySelector('[data-lk-altro-wrap]');
      var ALTRO = altroWrap ? (altroWrap.getAttribute('data-lk-altro-value') || '') : '';
      var altroInput = form.querySelector('[data-lk-altro-input]');
      var modelCombo = form.querySelector('[data-lk-combo] [data-lk-combo-value][name="properties[MODELLO]"]');
      function syncAltro() {
        if (!altroWrap || !altroInput || !modelCombo) return;
        var on = modelCombo.value === ALTRO;
        altroWrap.hidden = !on;
        if (on) { altroInput.setAttribute('data-lk-required', ''); altroInput.setAttribute('required', ''); }
        else { altroInput.removeAttribute('data-lk-required'); altroInput.removeAttribute('required'); altroInput.value = ''; setError(altroInput, false); }
      }
      if (modelCombo) {
        var comboRoot = modelCombo.closest('[data-lk-combo]');
        var comboInput = comboRoot && comboRoot.querySelector('[data-lk-combo-input]');
        if (comboInput) comboInput.addEventListener('change', syncAltro);
      }
      if (altroInput) altroInput.addEventListener('input', function () { if (altroInput.value.trim()) setError(altroInput, false); });
      syncAltro();

      if (listSel) listSel.addEventListener('change', syncList);
      if (listOther) listOther.addEventListener('input', function () { syncList(); if (listOther.value.trim()) setError(listOther, false); });
      syncList();
      if (brandSel) brandSel.addEventListener('change', fillModels);
      if (modelSel) modelSel.addEventListener('change', syncModel);
      if (modelOther) modelOther.addEventListener('input', function () { syncModel(); if (modelOther.value.trim()) setError(modelOther, false); });
      fillModels();

      /* ---------- Chip stile → hidden ---------- */
      var chipsValue = form.querySelector('[data-lk-chips-value]');
      var chips = form.querySelectorAll('[data-lk-chip]');
      function syncChips() {
        if (!chipsValue) return;
        var vals = [];
        chips.forEach(function (c) { if (c.checked) vals.push(c.value); });
        chipsValue.value = vals.join(', ');
      }
      chips.forEach(function (c) { c.addEventListener('change', syncChips); });



      /* ---- Base colori: parti in materiale speciale + materiale ---- */
      (function () {
        var bases = root.querySelectorAll('input[name="properties[COLORI DI STAMPA]"]');
        if (!bases.length) return;
        var matSet = root.querySelector('[data-lk-mat-set]');
        var matHint = root.querySelector('[data-lk-mat-hint]');
        var mats = root.querySelectorAll('.lk-mat input[type="radio"]');
        var matProp = root.querySelector('[data-lk-mat-prop]');
        var matPrev = root.querySelector('[data-lk-mat-prev]');
        var matCap = root.querySelector('[data-lk-mat-cap]');
        var MEDIA = { rosso: 'fluo-rosso', giallo: 'fluo-giallo', fucsia: 'fluo-fucsia', cromato: 'cromato', holo: 'holo' };
        function showMedia(key, label) {
          if (!matPrev) return;
          var want = MEDIA[key] || 'fluo-rosso';
          matPrev.querySelectorAll('[data-media]').forEach(function (el) {
            var on = el.dataset.media === want;
            el.hidden = !on;
            var v = el.querySelector('video');
            if (v) { if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
          });
          if (matCap && label) matCap.textContent = label;
        }
        var MAT = { rosso: '#ff2d1f', giallo: '#e3ff00', fucsia: '#ff2bb5' };
        var FILL = { rosso: '#ff2d1f', giallo: '#e3ff00', fucsia: '#ff2bb5',
                     cromato: 'url(#lk-g-chrome)', holo: 'url(#lk-g-holo)' };

        function currentMat() {
          for (var i = 0; i < mats.length; i++) { if (mats[i].checked) return mats[i]; }
          return mats[0];
        }
        function paint() {
          var m = currentMat();
          if (m) {
            var key = m.dataset.mat;
            root.style.setProperty('--lk-mat', 'var(--lk-mat-' + key + ')');
            root.style.setProperty('--lk-mat-solid', FILL[key] || '#ff2d1f');
            root.style.setProperty('--lk-mat-glow',
              MAT[key] ? 'drop-shadow(0 0 5px ' + MAT[key] + 'a6)' : 'none');
            showMedia(key, m.dataset.label);
          }
          var std = true;
          bases.forEach(function (b) {
            var plate = b.parentNode.querySelector('[data-lk-plate]');
            var parts = (b.dataset.parts || '').trim();
            if (plate) {
              plate.className = 'lk-plate';
              if (parts && parts !== 'std') {
                parts.split(/\s+/).forEach(function (x) { plate.classList.add('on-' + x); });
              }
            }
            if (b.checked && parts && parts !== 'std') std = false;
          });
          if (matSet) matSet.classList.toggle('is-muted', std);
          if (matProp) matProp.value = std ? '—' : (m ? m.value : '—');
          if (matHint) {
            matHint.textContent = std
              ? 'Serve solo se scegli una delle opzioni qui sopra: intanto guarda com\u2019\u00e8 fatto ogni materiale.'
              : 'Il disegno qui sopra si aggiorna. Passa il mouse su un materiale per vederlo da vicino.';
          }
        }
        bases.forEach(function (b) { b.addEventListener('change', paint); });
        mats.forEach(function (x) {
          x.addEventListener('change', paint);
          var lab = x.closest('label');
          if (!lab) return;
          function peek() { showMedia(x.dataset.mat, x.dataset.label); }
          function back() { var c = currentMat(); if (c) showMedia(c.dataset.mat, c.dataset.label); }
          lab.addEventListener('mouseenter', peek);
          lab.addEventListener('mouseleave', back);
          x.addEventListener('focus', peek);
          x.addEventListener('blur', back);
        });
        paint();
      })();

      /* ---------- Toggle → hidden properties ---------- */
      function hiddenFor(key) {
        return form.querySelector('input[type="hidden"][name="properties[' + key + ']"]');
      }
      form.querySelectorAll('[data-prop-toggle]').forEach(function (cb) {
        var h = hiddenFor(cb.dataset.propToggle);
        function sync() { if (h) h.value = cb.checked ? cb.dataset.on : 'NO'; }
        cb.addEventListener('change', sync);
        sync();
      });

      /* ---------- Casco: campo marca/modello ---------- */
      var cascoToggle = form.querySelector('[data-lk-casco-toggle]');
      var cascoField = form.querySelector('[data-lk-casco-field]');
      var cascoInput = form.querySelector('[data-lk-casco-field] [data-lk-combo-value]');

      if (cascoToggle && cascoField) {
        cascoToggle.addEventListener('change', function () {
          cascoField.hidden = !cascoToggle.checked;
          if (cascoToggle.checked) { var _ci = form.querySelector('[data-lk-casco-field] [data-lk-combo-input]'); if (_ci) _ci.focus(); }
        });
      }

      /* ---------- Prezzi ---------- */
      function variantFor(supp, addon) {
        if (supp) return cfg.supp[supp] || null;
        if (addon) return cfg[addon] || null;
        return null;
      }
      function priceOf(opt) {
        var v = variantFor(opt.dataset.supp, opt.dataset.addon);
        if (v && typeof v.price === 'number') return v.price;
        return parseInt(opt.dataset.price || '0', 10) || 0;
      }
      function collect() {
        var lines = [];
        var total = cfg.kit.price || 0;
        var controls = form.querySelectorAll('input[data-price]:checked, select[data-lk-addon-select]');
        controls.forEach(function (el) {
          var opt = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
          if (!opt) return;
          var supp = opt.dataset.supp, addon = opt.dataset.addon;
          if (!supp && !addon) return; /* opzione inclusa */
          var price = priceOf(opt);
          total += price;
          lines.push({ label: opt.dataset.label || '', price: price, supp: supp, addon: addon });
        });
        return { total: total, lines: lines };
      }
      function render() {
        var c = collect();
        totals.forEach(function (t) { t.textContent = fmt(c.total); });
        if (linesEl) {
          var html = '<li><span>' + escapeHtml(cfg.kit.title || 'Kit grafica') + '</span><span>' + fmt(cfg.kit.price || 0) + '</span></li>';
          c.lines.forEach(function (l) {
            html += '<li><span>' + escapeHtml(l.label) + '</span><span>+' + fmt(l.price) + '</span></li>';
          });
          linesEl.innerHTML = html;
        }
      }
      function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
      }
      form.addEventListener('change', render);
      function markChecked() { form.querySelectorAll('.lk-tile').forEach(function (t) { t.classList.toggle('is-checked', !!t.querySelector('input:checked')); }); }
      form.addEventListener('change', markChecked); markChecked();
      render();

      /* ---------- Validazione ---------- */
      form.querySelectorAll('[data-lk-required]').forEach(function (f) {
        f.addEventListener('input', function () { setError(f, false); });
        f.addEventListener('change', function () { setError(f, false); });
      });
      function setError(field, on) {
        var wrap = field.closest('.lk-field');
        if (!wrap) return;
        var err = wrap.querySelector('.lk-cfg__error');
        wrap.classList.toggle('has-error', on);
        if (err) err.hidden = !on;
        field.setAttribute('aria-invalid', on ? 'true' : 'false');
      }
      /* L'etichetta leggibile del campo: "Marca", non "properties[MARCA DELLA TUA MOTO]". */
      function etichettaCampo(f) {
        var wrap = f.closest('.lk-field');
        var lab = wrap && wrap.querySelector('label');
        if (lab) {
          for (var n = lab.firstChild; n; n = n.nextSibling) {
            if (n.nodeType === 3 && n.nodeValue.trim()) return n.nodeValue.trim();
          }
          return lab.textContent.split('*')[0].trim();
        }
        return (f.getAttribute('placeholder') || f.name || 'campo').trim();
      }
      /* Elenca i campi mancanti come pulsanti: ci si va SOLO se li tocchi tu. */
      function elencoMancanti(dest, campi) {
        if (!dest) return;
        while (dest.firstChild) dest.removeChild(dest.firstChild);
        dest.appendChild(document.createTextNode(campi.length === 1 ? 'Manca: ' : 'Mancano: '));
        campi.forEach(function (f) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'lk-cfg__missing';
          b.textContent = etichettaCampo(f);
          b.addEventListener('click', function () {
            f.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 350);
          });
          dest.appendChild(b);
        });
        dest.hidden = false;
      }
      function pulisciMancanti() {
        if (mbarMissing) { mbarMissing.hidden = true; while (mbarMissing.firstChild) mbarMissing.removeChild(mbarMissing.firstChild); }
      }
      function validate() {
        var mancanti = [];
        form.querySelectorAll('[data-lk-required]').forEach(function (f) {
          var empty = !f.value || !String(f.value).trim();
          setError(f, empty);
          if (empty) mancanti.push(f);
        });
        if (mancanti.length) {
          /* Niente scrollIntoView automatico: prima si scriveva cosa mancava e
             subito dopo si portava l'utente 7 schermate piu' su, lontano dal
             messaggio appena mostrato. Ora l'elenco compare dove sta guardando. */
          elencoMancanti(alertEl, mancanti);
          elencoMancanti(mbarMissing, mancanti);
          return false;
        }
        hideAlert();
        pulisciMancanti();
        return true;
      }
      function showAlert(msg) { if (!alertEl) return; alertEl.textContent = msg; alertEl.hidden = false; }
      function hideAlert() { if (!alertEl) return; alertEl.hidden = true; alertEl.textContent = ''; }

      /* ---------- Submit → /cart/add.js ---------- */
      var busy = false;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        if (!validate()) return;

        var props = {};
        var fd = new FormData(form);
        fd.forEach(function (v, k) {
          var m = k.match(/^properties\[(.+)\]$/);
          if (!m) return;
          v = String(v).trim();
          if (v !== '') props[m[1]] = v;
        });

        var items = [{ id: cfg.kit.id, quantity: 1, properties: props }];
        var missing = [];
        collect().lines.forEach(function (l) {
          var v = variantFor(l.supp, l.addon);
          if (!v || !v.id) { missing.push(l.label); return; }
          var it = { id: v.id, quantity: 1 };
          if (l.addon === 'casco') {
            it.properties = { 'ABBINATO AL KIT': 'Sì', 'MARCA/MODELLO CASCO': cascoInput ? cascoInput.value.trim() : '' };
          }
          items.push(it);
        });
        if (missing.length) {
          showAlert('Al momento non riusciamo ad aggiungere: ' + missing.join(', ') + '. Scrivici su WhatsApp e completiamo l\'ordine insieme.');
          if (alertEl && alertEl.scrollIntoView) alertEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        var cic = document.querySelector('cart-items-component');
        var sectionId = cic && cic.dataset ? cic.dataset.sectionId : null;
        var body = { items: items };
        if (sectionId) body.sections = sectionId;

        busy = true;
        hideAlert();
        submitBtn.classList.add('is-loading');
        submitBtn.setAttribute('aria-busy', 'true');
        var originalLabel = btnLabel ? btnLabel.textContent : '';
        if (btnLabel) btnLabel.textContent = 'Aggiungo…';

        fetch(cfg.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            if (!r.ok || r.data.status) {
              var msg = r.data.description || r.data.message || '';
              throw new Error(msg);
            }
            return fetch(cfg.routes.cartJs, { headers: { 'Accept': 'application/json' } })
              .then(function (res) { return res.json(); })
              .catch(function () { return null; })
              .then(function (cart) {
                var count = cart && typeof cart.item_count === 'number'
                  ? cart.item_count
                  : items.reduce(function (n, i) { return n + i.quantity; }, 0);
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart || {},
                    sourceId: 'licks-configurator',
                    data: { source: 'licks-configurator', itemCount: count, sections: r.data.sections || {} }
                  }
                }));
                submitBtn.classList.add('is-added');
                if (btnLabel) btnLabel.textContent = 'Aggiunto ✓';
                setTimeout(function () {
                  submitBtn.classList.remove('is-added');
                  if (btnLabel) btnLabel.textContent = originalLabel;
                }, 3000);
                if (!document.querySelector('cart-drawer-component')) {
                  window.location.href = cfg.routes.cart;
                }
              });
          })
          .catch(function (err) {
            console.error('[licks-configurator]', err);
            var extra = err && err.message ? ' (' + err.message + ')' : '';
            showAlert('Non siamo riusciti ad aggiungere il prodotto al carrello' + extra + '. Riprova tra qualche secondo o scrivici su WhatsApp.');
            if (btnLabel) btnLabel.textContent = originalLabel;
            if (alertEl) alertEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          })
          .then(function () {
            busy = false;
            submitBtn.classList.remove('is-loading');
            submitBtn.removeAttribute('aria-busy');
          });
      });

      /* ---------- Barra mobile: visibile finché il CTA principale non è in vista ---------- */
      var mbar = root.querySelector('[data-lk-mbar]');
      var mbarAdd = root.querySelector('[data-lk-mbar-add]');
      if (mbarAdd) {
        mbarAdd.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }
      if (mbar && submitBtn && 'IntersectionObserver' in window) {
        var startEl = form;
        var ctaVisible = false, formVisible = false;
        function updateBar() { mbar.hidden = ctaVisible || !formVisible; document.body.classList.toggle('lk-has-mbar', !mbar.hidden); }
        new IntersectionObserver(function (en) { ctaVisible = en[0].isIntersecting; updateBar(); }, { threshold: 0.2 }).observe(submitBtn);
        new IntersectionObserver(function (en) { formVisible = en[0].isIntersecting; updateBar(); }, { rootMargin: '200px 0px 0px 0px', threshold: 0 }).observe(startEl);
        var jump = mbar.querySelector('[data-lk-scroll]');
        if (jump) jump.setAttribute('href', '#' + form.getAttribute('id'));
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-licks-configurator]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["licks-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.__lkHeroRot = window.__lkHeroRot || {};
    function setupHero(hero) {
      var key = hero.id || 'hero';
      if (window.__lkHeroRot[key]) { clearTimeout(window.__lkHeroRot[key]); clearInterval(window.__lkHeroRot[key]); delete window.__lkHeroRot[key]; }
      var vids = Array.prototype.slice.call(hero.querySelectorAll('[data-lk-hero-video]'));
      if (vids.length < 2) return;
      if (window.matchMedia && (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.matchMedia('(max-width: 899px) and (hover: none)').matches)) return;
      var every = Math.max(4, parseInt(hero.dataset.lkRotate || '8', 10)) * 1000;
      var active = 0, busy = false;
      vids.forEach(function (v) { v.loop = true; v.muted = true; });
      function warm(v) { if (v.dataset.lkWarm) return; v.dataset.lkWarm = '1'; if (!v.src && v.dataset.lkSrc) v.src = v.dataset.lkSrc; v.preload = 'auto'; try { v.load(); } catch (e) {} }
      function swap() {
        if (busy || document.hidden || !hero.isConnected) return; busy = true;
        var n = (active + 1) % vids.length, nxt = vids[n], cur = vids[active];
        try { nxt.currentTime = 0; } catch (e) {}
        var p = nxt.play();
        var done = function () {
          nxt.classList.add('is-active'); cur.classList.remove('is-active'); active = n;
          setTimeout(function () { if (!cur.classList.contains('is-active')) { try { cur.pause(); } catch (e) {} } busy = false; }, 1600);
        };
        if (p && p.then) p.then(done).catch(function () { busy = false; }); else done();
      }
      /* ogni clip resta quanto dura lei, al massimo il tempo impostato:
         cosi la maschera (corta) sta meno della moto */
      function holdFor(v) {
        var d = (v && isFinite(v.duration) && v.duration > 0) ? v.duration * 1000 : every;
        return Math.max(3000, Math.min(every, d));
      }
      function warmNext(ms) { setTimeout(function () { warm(vids[(active + 1) % vids.length]); }, Math.max(800, ms - 3000)); }
      function schedule() {
        var ms = holdFor(vids[active]);
        warmNext(ms);
        window.__lkHeroRot[key] = setTimeout(function () { swap(); schedule(); }, ms);
      }
      if (vids[0].readyState >= 1) schedule();
      else vids[0].addEventListener('loadedmetadata', schedule, { once: true });
    }
    function init(root) { (root || document).querySelectorAll('.lk-hero').forEach(setupHero); }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { var h = e.target.querySelector('.lk-hero'); if (h && h.id && window.__lkHeroRot[h.id]) { clearInterval(window.__lkHeroRot[h.id]); delete window.__lkHeroRot[h.id]; } });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["licks-model-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BRANDS = [
      ['KTM', /\bktm\b/i], ['Husqvarna', /\bhusqvarna\b/i], ['GasGas', /\bgas ?gas\b/i], ['Beta', /\bbeta\b/i],
      ['Yamaha', /\byamaha\b/i], ['Honda', /\bhonda\b/i], ['Kawasaki', /\bkawasaki\b/i], ['Suzuki', /\bsuzuki\b/i],
      ['Sherco', /\bsherco\b/i], ['Fantic', /\bfantic\b/i], ['TM', /\btm\b/i]
    ];
    var ORDER = BRANDS.map(function (b) { return b[0]; });
    var stop = /^(kit|plastica|plastiche|parafango|copertura|parasteli|pannello|airbox|restyle|porta|front|guida|catena|\(|-)$/i;
    var ALL = '*';

    function setup(root) {
      if (root.dataset.lkInit) return; root.dataset.lkInit = '1';
      var fixedBrand = null;
      var db = (root.dataset.brand || '').trim();
      BRANDS.forEach(function (b) { if (!fixedBrand && db && b[1].test(db)) fixedBrand = b[0]; });
      var multi = !fixedBrand;

      var grid = root.querySelector('[data-lk-cards]');
      var bar = root.querySelector('[data-lk-bar]');
      var brandRow = root.querySelector('[data-lk-brand-row]');
      var modelRow = root.querySelector('[data-lk-model-row]');
      var brandBox = root.querySelector('[data-lk-brand-chips]');
      var modelBox = root.querySelector('[data-lk-model-chips]');
      var empty = root.querySelector('[data-lk-empty]');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.licks-mcat__card'));

      function parse(title) {
        var t = title.replace(/\s+/g, ' ').trim();
        var brand = fixedBrand || 'Altre marche';
        BRANDS.forEach(function (b) { if (b[1].test(t)) { if (!fixedBrand) brand = b[0]; t = t.replace(b[1], ' '); } });
        var words = t.replace(/\s+/g, ' ').trim().split(' ');
        var model = [], year = 0, yearStr = '', rest = [];
        var i = 0;
        for (; i < words.length; i++) {
          var w = words[i];
          var m = w.match(/^((?:19|20)\d{2})(?:-((?:19|20)?\d{2}))?\+?$/) || w.match(/^(\d{2})-(\d{2})\+?$/);
          if (m) { year = parseInt(m[1], 10); if (year < 100) year += 2000; yearStr = w; i++; break; }
          if (stop.test(w)) break;
          model.push(w);
        }
        for (; i < words.length; i++) { if (words[i] !== '-') rest.push(words[i]); }
        var name = model.join(' ');
        if (!name || /^kit$/i.test(name)) name = 'Altri ricambi';
        var restTxt = rest.join(' ').replace(/\s*\((NON PER|NOT FOR)\s+([^)]*)\)/i, ' · non per $2');
        restTxt = restTxt.toLowerCase().replace(/\b(smr|sx|exc|ktm|tc|fc|te|fe|mc|ec|rr|yz|crf|kx|rmz)\b/g, function (m) { return m.toUpperCase(); });
        return { brand: brand, model: name, year: year, yearStr: yearStr, rest: restTxt };
      }

      var brands = {};
      cards.forEach(function (c) {
        var p = parse(c.dataset.lkTitle || c.textContent);
        c.dataset.lkBrand = p.brand; c.dataset.lkModel = p.model; c.dataset.lkYear = p.year;
        var ml = c.querySelector('[data-lk-model-label]'), tl = c.querySelector('[data-lk-type]');
        if (ml && p.model !== 'Altri ricambi') ml.textContent = ((p.brand === 'Altre marche' ? '' : p.brand + ' ') + p.model + (p.yearStr ? ' ' + p.yearStr : '')).trim();
        if (tl && p.rest) tl.textContent = p.rest.charAt(0).toUpperCase() + p.rest.slice(1);
        if (tl && (!p.rest || p.model === 'Altri ricambi')) tl.textContent = '';
        var B = brands[p.brand] = brands[p.brand] || { n: 0, models: {} };
        B.n++;
        var M = B.models[p.model] = B.models[p.model] || { n: 0 };
        M.n++;
      });
      var brandNames = Object.keys(brands).sort(function (a, b) {
        var ia = ORDER.indexOf(a), ib = ORDER.indexOf(b);
        if (ia < 0) ia = 99; if (ib < 0) ib = 99;
        return ia - ib || brands[b].n - brands[a].n || a.localeCompare(b);
      });
      function modelNames(brand) {
        var ms = brands[brand] ? brands[brand].models : {};
        return Object.keys(ms).sort(function (a, b) {
          if (a === 'Altri ricambi') return 1; if (b === 'Altri ricambi') return -1;
          return ms[b].n - ms[a].n || a.localeCompare(b);
        });
      }

      var state = { brand: multi ? ALL : fixedBrand, model: ALL };

      function render() {
        grid.innerHTML = '';
        var shown = 0;
        brandNames.forEach(function (bn) {
          if (state.brand !== ALL && state.brand !== bn) return;
          modelNames(bn).forEach(function (mn) {
            if (state.model !== ALL && state.model !== mn) return;
            var list = cards.filter(function (c) { return c.dataset.lkBrand === bn && c.dataset.lkModel === mn; })
              .sort(function (a, b) { return (b.dataset.lkKit === 'true') - (a.dataset.lkKit === 'true') || (a.dataset.lkYear - b.dataset.lkYear) || a.dataset.lkTitle.localeCompare(b.dataset.lkTitle); });
            if (!list.length) return;
            var h = document.createElement('div'); h.className = 'licks-mcat__group';
            h.innerHTML = '<h3></h3><span></span>';
            h.querySelector('h3').textContent = (bn === 'Altre marche' ? '' : bn + ' ') + mn;
            h.querySelector('span').textContent = list.length + (list.length === 1 ? ' articolo' : ' articoli');
            grid.appendChild(h);
            list.forEach(function (c) { c.classList.add('lk-reveal'); c.classList.remove('is-in'); grid.appendChild(c); shown++; });
          });
        });
        empty.hidden = shown > 0;
        if (window.LicksMotion) window.LicksMotion.init(grid);
      }

      function chip(label, value, count, onClick) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab');
        b.dataset.value = value; b.innerHTML = '<span></span><small></small>';
        b.querySelector('span').textContent = label; b.querySelector('small').textContent = '(' + count + ')';
        b.addEventListener('click', onClick);
        return b;
      }
      function select(box, value) {
        box.querySelectorAll('button').forEach(function (x) {
          var on = x.dataset.value === value;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && box.scrollWidth > box.clientWidth) box.scrollTo({ left: x.offsetLeft - box.clientWidth / 2 + x.offsetWidth / 2, behavior: 'smooth' });
        });
      }
      function scrollToBar() {
        var y = bar.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72) - 8;
        if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
      }
      function syncHash() {
        if (!history.replaceState) return;
        var parts = [];
        if (multi && state.brand !== ALL) parts.push('marca=' + encodeURIComponent(state.brand));
        if (state.model !== ALL) parts.push('modello=' + encodeURIComponent(state.model));
        history.replaceState(null, '', location.pathname + location.search + (parts.length ? '#' + parts.join('&') : ''));
      }

      function buildModels() {
        modelBox.innerHTML = '';
        if (multi && state.brand === ALL) { modelRow.hidden = true; return; }
        modelRow.hidden = false;
        var total = brands[state.brand] ? brands[state.brand].n : 0;
        modelBox.appendChild(chip('Tutti i modelli', ALL, total, function () { state.model = ALL; select(modelBox, ALL); render(); scrollToBar(); syncHash(); }));
        modelNames(state.brand).forEach(function (mn) {
          modelBox.appendChild(chip(mn, mn, brands[state.brand].models[mn].n, function () { state.model = mn; select(modelBox, mn); render(); scrollToBar(); syncHash(); }));
        });
        select(modelBox, state.model);
      }
      function setBrand(bn) {
        state.brand = bn; state.model = ALL;
        select(brandBox, bn); buildModels(); render(); scrollToBar(); syncHash();
      }

      if (multi) {
        brandRow.hidden = false;
        brandBox.appendChild(chip('Tutte le marche', ALL, cards.length, function () { setBrand(ALL); }));
        brandNames.forEach(function (bn) { brandBox.appendChild(chip(bn, bn, brands[bn].n, function () { setBrand(bn); })); });
      }

      var hb = location.hash.match(/marca=([^&]+)/), hmv = location.hash.match(/modello=([^&]+)/);
      function dec(x) { try { return decodeURIComponent(x); } catch (e) { return ''; } }
      if (multi && hb) { var bv = dec(hb[1]); if (brands[bv]) state.brand = bv; }
      if (hmv) { var mv = dec(hmv[1]); if (state.brand !== ALL && brands[state.brand] && brands[state.brand].models[mv]) state.model = mv; }
      if (multi) select(brandBox, state.brand);
      buildModels();
      render();

      if ('IntersectionObserver' in window) {
        var sentinel = document.createElement('div'); sentinel.style.height = '1px'; bar.parentNode.insertBefore(sentinel, bar);
        new IntersectionObserver(function (e) { bar.classList.toggle('is-stuck', !e[0].isIntersecting); }, { rootMargin: '-90px 0px 0px 0px' }).observe(sentinel);
      }
    }
    function init(root) { (root || document).querySelectorAll('[data-lk-mcat]').forEach(setup); }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["licks-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-lk-reviews]').forEach(function (section) {
        if (section.dataset.lkReady) return;
        section.dataset.lkReady = '1';
        var track = section.querySelector('[data-lk-track]');
        if (!track) return;
        function step() {
          var card = track.firstElementChild;
          return card ? card.getBoundingClientRect().width + 16 : 320;
        }
        var prev = section.querySelector('[data-lk-prev]');
        var next = section.querySelector('[data-lk-next]');
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["licks-video-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(root) {
      (root || document).querySelectorAll('[data-lk-video-wall]').forEach(function (section) {
        if (section.dataset.lkReady) return;
        section.dataset.lkReady = '1';
        var videos = section.querySelectorAll('[data-lk-video]');
        if (!videos.length) return;

        section.querySelectorAll('[data-lk-sound]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var video = btn.parentElement.querySelector('[data-lk-video]');
            if (!video) return;
            var on = video.muted;
            video.muted = !on;
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            btn.setAttribute('aria-label', on ? 'Disattiva audio' : 'Attiva audio');
            if (on) video.play().catch(function () {});
          });
        });

        if (reduce || !('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting && en.intersectionRatio >= 0.5) {
              v.play().catch(function () {});
            } else {
              v.pause();
            }
          });
        }, { threshold: [0, 0.5] });
        videos.forEach(function (v) { io.observe(v); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
